// src/components/join/JoinWaiting.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useJoin } from './joinContext';
import { renderLinkifiedText } from '../../utils/linkify';

export default function JoinWaiting() {
  const { team, teamId, user, status, pendingMemberStatus, stripeSetup } = useJoin();
  const hasAdminAccess = Boolean(user?.uid && (
    team?.admins?.includes(user.uid)
    || team?.myAdminAssignment?.permissionKeys?.length > 0
  ));
  const clubId = teamId || team?.id;

  if (status === 'waitlisted') {
    return (
      <div className="text-center">
        <h2 className="text-2xl font-semibold mb-2">You&apos;re on the waitlist</h2>
        <p className="text-gray-700">
          You&apos;ve completed the join steps for <strong>{team?.name}</strong>, but spaces are currently being managed by the club.
        </p>
        <p className="text-muted mt-4">
          You won&apos;t be asked to pay until an admin releases you from the waitlist. We&apos;ll notify you when payment is available.
        </p>
      </div>
    );
  }

  if (pendingMemberStatus === 'awaiting_club_payment') return (
    <div>
      <h2 className="join-flow-section-title">Waiting for payment confirmation</h2>
      <p>Arrange your membership payment directly with <strong>{team?.name}</strong>. An administrator will confirm payment and activate your membership. You do not need to pay through Stripe.</p>
      <div className="join-external-payment-instructions">
        <h3>How to pay</h3>
        <p>{renderLinkifiedText(stripeSetup?.externalPaymentInstructions || 'Contact your club treasurer for payment instructions.')}</p>
      </div>
      <p className="text-muted">If you have already paid, wait for the club to confirm it. You’ll be notified when your membership is active.</p>
      {hasAdminAccess && clubId && <div className="join-family-coverage">
        <p>Your admin access remains available while your own payment is awaiting confirmation. You can continue managing the club with your existing permissions.</p>
        <Link className="button button-primary" to={`/teams/${clubId}`}>Return to club administration</Link>
      </div>}
    </div>
  );

  return (
    <div className="text-center">
      <h2 className="text-2xl font-semibold mb-2">Request Sent</h2>
      <p className="text-gray-700">
        You've submitted your request to join <strong>{team?.name}</strong>. An admin will review your application and approve it if successful.
      </p>
      <p className="text-muted mt-4">
        You’ll be notified by email or can return here later to complete your registration.
      </p>
    </div>
  );
}
